import React from 'react';
import { TouchableOpacity, Text, Platform } from 'react-native';

type FABProps = {
  visible?: boolean;
  onPress?: () => void;
  bottomOffset?: number;
  children?: React.ReactNode;
  style?: any;
};

const FloatingActionButton: React.FC<FABProps> = ({ visible = true, onPress, bottomOffset = 24, children, style }) => {
  if (!visible) return null;
  // lift FAB on web to sit above bottom nav / affordance
  const webLift = 80; // px
  const webStyle: any = { position: 'fixed', right: 24, bottom: bottomOffset + webLift, zIndex: 2147483648 };
  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.85}
      style={[
        {
          width: 44,
          height: 44,
          borderRadius: 22,
          backgroundColor: '#FB7A4A',
          alignItems: 'center',
          justifyContent: 'center',
          shadowColor: '#FB7A4A',
          shadowOpacity: 0.18,
          shadowOffset: { width: 0, height: 6 },
          shadowRadius: 10,
          elevation: 6,
        },
        Platform.OS === 'web' ? webStyle : {},
        style,
      ]}
    >
      {children ?? <Text style={{ color: '#fff', fontWeight: '700', fontSize: 20 }}>＋</Text>}
    </TouchableOpacity>
  );
};

export default FloatingActionButton;
